<ada-container
	*ngIf="(isHidden$ | async) === false"
	overflowY="auto"
	[height]="'100%'"
	[showAsColumn]="true"
>
	<ada-container
		class="ada-border-bottom ada-background-color-background ada-editor-sticky-header"
		padding="{{ ui.Spacing.SPACING_MEDIUM }} {{ ui.Spacing.SPACING_LARGE }}"
	>
		<ada-push-button
			text="Save"
			tooltip="Save Cloud Content Settings"
			[adaClick]="save | adaBindMethod: this"
			[colSpan]="0"
			[isDisabled]="!state || (state.isChanged | async) !== true"
		/>
	</ada-container>
	<ada-container
		padding="{{ ui.Spacing.SPACING_LARGE }}"
		verticalSpacing="medium"
	>
		<ada-card [collapseEnabled]="true">
			<div
				class="ada-container ada-flex-align-center"
				data-container-selector="ada-card-header"
			>
				<span ada-color="foreground">Content Publication Settings</span>
				<ada-signpost
					ada-type="base"
					style="margin-left: 0.5rem"
				>
					<span ada-color="foreground">
						Tell {{ systemConfig.appDisplayName | async }} where to store your content. You can store it in the
						{{ systemConfig.appDisplayName | async }} Server Content Library, Cloud Storage, or both. One or more selections required.
					</span>
				</ada-signpost>
			</div>
			<div
				class="ada-container ada-colspan-1 ada-col-4 ada-vspacing-medium ada-hspacing-medium"
				data-container-selector="ada-card-body"
				style="padding: 0 1rem 1.25rem 1rem"
			>
				<span
					ada-color="foreground"
					class="ada-colspan-1"
				>
					Publish Content on:
				</span>
				<div class="ada-container ada-colspan-3 ada-col-1 ada-vspacing-medium">
					<ada-checkbox
						#ContentPublicationInput
						label="{{ systemConfig.appDisplayName | async }} Server"
						[isChecked]="state?.value?.publishContentOnAdaptivaServer"
						[isDisabled]="isDisabled$ | async"
						(isCheckedChange)="state.set('publishContentOnAdaptivaServer', $event)"
					/>
					<ada-checkbox
						label="Cloud Storage"
						[isChecked]="state?.value?.publishContentInCloudStore"
						[isDisabled]="isDisabled$ | async"
						(isCheckedChange)="state.set('publishContentInCloudStore', $event)"
					/>
				</div>
			</div>
		</ada-card>
	</ada-container>
</ada-container>
